import { Checkbox, FormControlLabel } from '@mui/material'
import React, { Fragment } from 'react'
import { trans } from '../../_providers/Translation'

//NEW: Компонент за списък с чекбокси за права
function PermissionCheckboxList({ perms, selectedPerms, onChange }) {
    const isSelected = (perm) => selectedPerms.some(sel => sel.value === perm.value)

    // Брой маркирани деца за даден родител
    const selectedChildrenCount = (parent) =>
        (parent.children || []).filter(child => isSelected(child)).length

    const allChildrenSelected = (parent) =>
        (parent.children || []).length > 0 && selectedChildrenCount(parent) === parent.children.length

    const someChildrenSelected = (parent) =>
        selectedChildrenCount(parent) > 0 && !allChildrenSelected(parent)

    // Маркиране/демаркиране на родител -> прехвърля се върху всички деца
    const handleParentChange = (e, parent) => {
        let selected = Array.isArray(selectedPerms) ? [...selectedPerms] : []
        const children = parent.children || []

        if (e.target.checked) {
            // Добавяме родителя и всички деца (без дубликати)
            const toAdd = [parent, ...children].filter(p => !selected.some(sel => sel.value === p.value))
            selected = [...selected, ...toAdd]
        } else {
            // Премахваме родителя и всички деца
            const removeValues = [parent.value, ...children.map(c => c.value)]
            selected = selected.filter(sel => !removeValues.includes(sel.value))
        }

        onChange(selected)
    }

    // Маркиране/демаркиране на дете -> авто-актуализира родителя
    const handleChildChange = (e, parent, child) => {
        let selected = Array.isArray(selectedPerms) ? [...selectedPerms] : []

        if (e.target.checked) {
            selected.push(child)
        } else {
            selected = selected.filter(sel => sel.value !== child.value)
        }

        const children = parent.children || []
        const selectedChildren = children.filter(c => selected.some(sel => sel.value === c.value))

        const parentSelected = selected.some(sel => sel.value === parent.value)

        if (selectedChildren.length > 0 && !parentSelected) {
            // Поне едно дете е маркирано -> родителят се добавя
            selected.push(parent)
        } else if (selectedChildren.length === 0 && parentSelected) {
            // Няма маркирани деца -> родителят се премахва
            selected = selected.filter(sel => sel.value !== parent.value)
        }

        onChange(selected)
    }

    // Маркиране/демаркиране на самостоятелен чекбокс (без деца)
    const handleSingleChange = (e, perm) => {
        let selected = Array.isArray(selectedPerms) ? [...selectedPerms] : []
        if (e.target.checked) {
            selected.push(perm)
        } else {
            selected = selected.filter(sel => sel.value !== perm.value)
        }
        onChange(selected)
    }

    if (!perms || perms.length === 0) {
        return <div className="alert warning">
            {trans('messages.noPermissionsAvailable')}
        </div>
    }
    return (
        <>
            {perms.map(perm => {
                const hasChildren = (perm.children || []).length > 0
                return (
                    <Fragment key={perm.value}>
                        <FormControlLabel

                            control={
                                <Checkbox
                                    size='small'
                                    indeterminate={hasChildren ? someChildrenSelected(perm) : false}
                                />
                            }
                            value={perm.value}
                            checked={hasChildren ? allChildrenSelected(perm) : isSelected(perm)}
                            onChange={e => hasChildren
                                ? handleParentChange(e, perm)
                                : handleSingleChange(e, perm)
                            }
                            label={perm.label}
                            sx={{
                                margin: "-7px 0"
                            }}
                        />
                        {hasChildren ? perm.children.map(child => (
                            <FormControlLabel
                                key={child.value}
                                control={
                                    <Checkbox size='small' />
                                }
                                value={child.value}
                                checked={isSelected(child)}
                                onChange={e => handleChildChange(e, perm, child)}
                                label={child.label}
                                sx={{
                                    margin: "-7px 0",
                                    marginLeft: "25px"
                                }}
                            />
                        )) : <></>}
                    </Fragment>
                )
            })}
            {/* Hidden inputs for form submission, like MultiSelect */}
            {selectedPerms.map(s =>
                <input key={'m-' + s.value} type="hidden" name="perms[]" value={s.value} />
            )}
        </>
    )
}

export default PermissionCheckboxList
